/**
 * Composing <Route> in React Router v6
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 *
 * Upgrading from v5
 * https://reactrouter.com/docs/en/v6/upgrading/v5
 */
import { Routes, Route, useNavigate } from "react-router-dom";

import { useAuth } from "context/AuthContext";

import { NotFound } from "pages/NotFound";
import { PrivateRoute } from "./PrivateRoute";
import { PublicRoute } from "./PublicRoute";
import CustomNavigationClient from "sso/azure/CustomNavigationClient";
import { MsalProvider } from "@azure/msal-react";
import { Wait } from "pages/Wait";
import Realizations from "pages/Realizations";
import Subscribe from "pages/Realizations/Subscribe";
import Success from "pages/Realizations/Success";
import { Login1002 } from "pages/Auth/Login1002";
import { Login } from "pages/Auth/Login";
import Evaluation from "pages/Evaluation";
import Vote from "pages/Evaluation/Vote";
import SuccessEvaluation from "pages/Evaluation/Success";
import { useEffect, useState } from "react";
import { StageIds } from "utils/constants";
import Winners from "pages/Winners";
import Spinner from "components/ui/Spinner";
import DirectorEvaluationVote from "pages/GuestEvaluation/Vote";
import DirectorEvaluation from "pages/GuestEvaluation";
import Result from "pages/Result";
import IndicatedList from "pages/indicatedList";
import Classificadas from "pages/Classificadas";

export const RouteList = ({ msalInstance }: any) => {
  const { currentStep, user } = useAuth();
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  msalInstance.setNavigationClient(navigationClient);

  const InitialRedirect = () => {
    useEffect(() => {
      if (!user || !currentStep) return;
      if (
        user.detail &&
        user.detail.tipo_de_acordo === "PREDEFINIDO" &&
        !user.detail.isBoss &&
        !user.detail.acessor
      ) {
        navigate("/winners");
      } else if (currentStep?._id === StageIds.STAGE_INSCRICAO) {
        navigate("/realizations");
      } else if (currentStep?._id === StageIds.STAGE_UM_AVALIACAO) {
        navigate("/evaluation");
      } else if (
        currentStep?._id === StageIds.STAGE_DOIS_AVALIACAO &&
        (user?.detail.isBoss ||
          (user?.detail.acessor && user?.detail.acessor.vp))
      ) {
        navigate("/evaluation-president");
      } else if (
        (currentStep?._id === StageIds.STAGE_DOIS_AVALIACAO &&
          !user?.detail.isBoss) ||
        (currentStep._id === StageIds.STAGE_DOIS_AVALIACAO &&
          !(
            user?.detail.isBoss ||
            (user?.detail.acessor && user?.detail.acessor.vp)
          ))
      ) {
        navigate("/winners");
      } else if (currentStep?._id === StageIds.STAGE_TRES_AVALIACAO_DIRETOR || currentStep?._id === StageIds.STAGE_AGUARDANDO_RESULTADO) {
        navigate("/evaluation-realization");
      } else if (currentStep?._id === StageIds.STAGE_ENTREGA) {
        navigate("/result");
      } else {
        navigate("/winners");
      }
    }, [currentStep, navigate, user]);

    return null;
  };

  const canView = () => {
    //currentStep?._id === StageIds.STAGE_TRES_AVALIACAO_DIRETOR
  };

  return (
    <MsalProvider instance={msalInstance}>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute redirectTo="/login">
              {!user || !currentStep ? (
                <div className="flex items-start justify-center w-full h-screen">
                  <div className="flex flex-col">
                    <Spinner />
                    <span className="text-center text-blue-bb">
                      Verificando etapa atual...
                    </span>
                  </div>
                </div>
              ) : (
                <InitialRedirect />
              )}
            </PrivateRoute>
          }
        />

        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login1002 />
            </PublicRoute>
          }
        />

        <Route
          path="/login-especialista"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path={"/wait"}
          element={
            <PrivateRoute redirectTo="/login">
              <Wait />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path={"/winners"}
          element={
            <PrivateRoute redirectTo="/login">
              <Winners />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path="/realizations"
          element={
            <PrivateRoute redirectTo="/login">
              <Realizations />
            </PrivateRoute>
          }
        />

        <Route
          path="/realizations/subscribe"
          element={
            <PrivateRoute redirectTo="/login">
              <Subscribe />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/realizations/success"
          element={
            <PrivateRoute redirectTo="/login">
              <Success />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/evaluation"
          element={
            <PrivateRoute redirectTo="/login">
              <Evaluation />
            </PrivateRoute>
          }
        />

        <Route
          path="/evaluation/vote"
          element={
            <PrivateRoute redirectTo="/login">
              <Vote />
            </PrivateRoute>
          }
        />

        <Route
          path="/evaluation/success"
          element={
            <PrivateRoute redirectTo="/login">
              <SuccessEvaluation />
            </PrivateRoute>
          }
        />

        <Route
          path="/evaluation-president"
          element={
            <PrivateRoute redirectTo="/login">
              <Evaluation />
            </PrivateRoute>
          }
        />

        <Route
          path="/evaluation-president/vote"
          element={
            <PrivateRoute redirectTo="/login">
              <Vote />
            </PrivateRoute>
          }
        />

        <Route
          path="/evaluation-president/success"
          element={
            <PrivateRoute redirectTo="/login">
              <SuccessEvaluation />
            </PrivateRoute>
          }
        />
        <Route
          path="/evaluation-realization"
          element={
            <PrivateRoute redirectTo="/login">
              <DirectorEvaluation />
            </PrivateRoute>
          }
        />
        <Route
          path="/evaluation-realization/vote"
          element={
            <PrivateRoute redirectTo="/login">
              <DirectorEvaluationVote />
            </PrivateRoute>
          }
        />
        <Route
          path="/result"
          element={
            <PrivateRoute redirectTo="/login">
              <Result />
            </PrivateRoute>
          }
        />
        <Route
          path="/start"
          element={
            <PrivateRoute redirectTo="/login">
              <Realizations />
            </PrivateRoute>
          }
        />

        <Route
          path="/indicated-list"
          element={
            <PrivateRoute redirectTo="/login">
              <IndicatedList />
            </PrivateRoute>
          }
        />

        <Route
          path="/classificadas"
          element={<Classificadas />}
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </MsalProvider>
  );
};
